module.exports = __webpack_public_path__ + "static/media/445821-PF5LWD-853.0d59424e.png";